define('ANSI/Components/Content/CardVerticalHover',['jquery'], function ($) {
    'use strict';

    function CardVerticalHover(scope) {
        Object.defineProperty(this, 'scope', { enumerable: true, value: scope, writable: !1 });
        Object.defineProperty(this, '$scope', { enumerable: !0, value: $(scope) });

        var getLineHeight = function (element) {
            var lineHeight = window.getComputedStyle(element)['line-height'];
            return lineHeight === 'normal' ? 1.16 * parseFloat(window.getComputedStyle(element)['font-size']) : parseFloat(lineHeight);
        };

        this.$scope.find('a, .card-body').each(function (i, item) {
            var $item = $(item);

            $item.attr('data-text-content', item.textContent);
            $item.attr('data-line-height', getLineHeight(item));
            $item.attr('lang', document.documentElement.lang);
        });

        this._updateItems();

        var self = this;
        $(document).on('shown.bs.tab', '.page-wrapper a[data-toggle="tab"]', function (e) {
            self._updateItems();
        });
    }


    CardVerticalHover.prototype._updateItems = function () {
        var self = this;

        this.$scope.find('a').each(function (i, item) {
            self._doEllipsis(3, item);
        });

        this.$scope.find('.card-body').each(function (i, item) {
            self._doEllipsis(3, item);
        });
    };

    CardVerticalHover.prototype._doEllipsis = function (lines, element) {
        var $element = $(element),
            inner = document.createElement('SPAN'),
            text = $element.attr('data-text-content'),
            lineHeight = $element.attr('data-line-height'),
            maxHeight = lines * lineHeight,
            textParts = text.split(' ');

        if ( !text ) return;

        element.innerHTML = '';
        element.style.height = 'auto';
        element.style.maxHeight = maxHeight + 'px';
        element.appendChild(inner);
        inner.innerHTML = text;
        inner.style.display = 'block';

        if ( inner.clientHeight < maxHeight ) return;

        while (inner.clientHeight > maxHeight) {
            textParts.pop();
            inner.innerHTML = textParts.join(' ') + '...';
        }
    };


    CardVerticalHover.init = function init(args) {
        return args.IsEditorEditing === true ? null : new CardVerticalHover(args.scope);
    };

    return CardVerticalHover;

});
